import { Icon } from '@/components/Icon'
import { type IconNames } from '@/components/Icon/Icons'
import { storeConsent, loadPrivacyManager } from '@/libs/consent/consent'
import { SocialVendor } from '@/types/consent'
import styles from './EmbedDefault.module.scss'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'
import Button from '@/components/Button/Button'

export const socialMap: {
  [k in SocialVendor]: {
    name: string
    icon: IconNames
    vendor: SocialVendor
  }
} = {
  facebook: {
    name: 'Facebook',
    icon: 'facebookColor',
    vendor: 'facebook',
  },
  instagram: {
    name: 'Instagram',
    icon: 'instagramColor',
    vendor: 'instagram',
  },
  tiktok: {
    name: 'TikTok',
    icon: 'tiktokColor',
    vendor: 'tiktok',
  },
  x: {
    name: 'X',
    icon: 'x',
    vendor: 'x',
  },
  youtube: {
    name: 'YouTube',
    icon: 'youtubeColor',
    vendor: 'youtube',
  },
  truthsocial: {
    name: 'Truth Social',
    icon: 'truthsocialColor',
    vendor: 'truthsocial',
  },
}

const NoConsent = ({
  provider,
  purMode,
  setShowEmbed,
  cookies,
}: {
  provider: SocialVendor
  purMode: boolean
  setShowEmbed: (show: boolean) => void
  cookies: RequestCookie[]
}) => {
  const setConsent = () => {
    setShowEmbed(true)
    storeConsent(cookies, provider)
  }

  const callPrivacyManager = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    loadPrivacyManager()
  }

  const name = socialMap[provider] ? socialMap[provider].name : ''

  return (
    <div className={styles.noconsent}>
      <div className={styles.wrapper}>
        <div className={styles['left-block']}>
          <strong>Empfohlener Inhalt</strong>
          {!purMode && (
            <p>
              Aufgrund Ihrer Privacy Einstellungen können wir an dieser Stelle keinen Inhalt der externen Plattform{' '}
              {name} anzeigen. Sie können sich den Inhalt mit einem Click wieder anzeigen lassen und im{' '}
              <a href="https://www.n-tv.de/15745191" onClick={(event) => callPrivacyManager(event)}>
                Privacy Center
              </a>{' '}
              weitere Einstellungen anpassen.
            </p>
          )}
          {purMode && (
            <p>
              Auf Grund ihrer Privatsphären-Einstellungen können wir an dieser Stelle keine Inhalt der externen
              Plattform {name} anzeigen. Um diesen (und weitere) Inhalt(e) für Ihre laufende Sitzung anzuzeigen, klicken
              Sie bitte auf &quot;Inhalte von {name} anzeigen&quot;. Ihre Zustimmung wird bis zum Schließen des Browsers
              mit einem Cookie gespeichert und danach verworfen. Im Falle einer Zustimmung erfolgt evtl. ein
              Datentransfer und eine Datenverarbeitung außerhalb des EWR (Art. 49 (1) (a) DSGVO, Drittlandtransfer), wo
              das hohe europäische Datenschutzniveau nicht besteht. Sie stimmen diesem Drittlandtransfer ebenfalls zu.
            </p>
          )}
        </div>
        <div className={styles['right-block']}>
          <Icon name={socialMap[provider].icon} />
        </div>
      </div>
      <Button onClick={() => setConsent()} className={styles.btn}>
        Inhalt von {name} anzeigen
      </Button>
    </div>
  )
}

export default NoConsent
